import { render } from "./PrescriberSignature.vue?vue&type=template&id=3e800030&scoped=true"
import script from "./PrescriberSignature.vue?vue&type=script&lang=js"
export * from "./PrescriberSignature.vue?vue&type=script&lang=js"

import "./PrescriberSignature.vue?vue&type=style&index=0&id=3e800030&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e800030"]])

export default __exports__